import { createAsyncThunk } from '@reduxjs/toolkit'

import { fetchCurrencies } from '@app/api'
import { getUserLanguage } from '@app/utils'

export const getCurrenciesThunk = createAsyncThunk(
  'currencies',
  async () => {
    const userLanguage = getUserLanguage()

    return await fetchCurrencies(userLanguage)
  }
)
